import styled from 'styled-components';
import { CONFIG } from '../../../../constants';

const primary = CONFIG.COLOR_PRIMARY;
const background = '#ffffff';
const border = '#f0f0f0';

export const inputStyle = () => {
  const style = { padding: 16, minWidth: 50 };
  return {
    ...style,
    background
  };
};

export const landingTitleStyle = () => {
  const style = { padding: 16, minWidth: 200 };
  return {
    ...style,
    background
  };
};

export const landingContentStyle = () => {
  const style = { padding: 16, minWidth: 200 };
  return {
    ...style,
    fontWeight: 'normal',
    background
  };
};

export const Header = styled.div`
  font-size: 20px;
  font-weight: bold;
`;

export const Container = styled.div`
  border: ${(props) =>
    props.selected ? `2px solid ${primary}` : `2px solid ${border}`};
  border-radius: 6px;
  ${(props) =>
    !props.isMobile && props.hover
      ? `&:hover {
    border: 2px solid ${primary};
  }`
      : ``};
`;

export const stepStyle = {
  boxShadow: '0px -1px 0 0 #e8e8e8 inset'
};
